import React, { Component, Fragment } from 'react'
import Fuse from 'fuse.js'
import PropTypes from 'prop-types'
import {
  ModalHeaderContentContainer,
  SearchTitle,
  SearchInput,
  SearchContentContainer,
  NoElementsFound,
  ModalHeader,
  SingleElementFoundMessage,
} from '../styled'

class CollectionSearchComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchText: '',
      stateCollection: props.collection,
    }
    this.providedCollection = props.collection
    this.availableStores = new Fuse(props.collection, {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: props.searchKeys,
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { stateCollection, searchText } = this.state
    if (stateCollection.length !== nextState.stateCollection.length) {
      return true
    }
    if (searchText !== nextState.searchText) {
      return true
    }
    return false
  }

  updateSearch = (event) => {
    const search = event.target.value
    if (search === '') {
      this.setState({ stateCollection: this.providedCollection, searchText: search })
    } else {
      this.setState({
        stateCollection: this.availableStores.search(search),
        searchText: search,
      })
    }
  }

  render() {
    const {
      collection,
      searchKeys,
      title,
      singleElementMessage,
      SearchResultElement,
      searchPlaceholder,
      noFoundMessage,
      closeModalAction,
    } = this.props
    const { searchText } = this.state
    const { stateCollection } = this.state

    this.availableStores = new Fuse(collection, {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      distance: 100,
      maxPatternLength: 64,
      minMatchCharLength: 1,
      keys: searchKeys,
    })
    this.providedCollection = collection
    if (stateCollection.length === 0 && collection.length > 0 && searchText === '') {
      this.setState({
        stateCollection: collection,
      })
    }

    return (
      <Fragment>
        <ModalHeader>
          <ModalHeaderContentContainer>
            <div className="col-12">
              <SearchTitle>{title}</SearchTitle>
            </div>
            {this.providedCollection.length > 1 && (
              <div className="col-12" style={{ marginBottom: '28px' }}>
                <SearchInput
                  type="search"
                  autoFocus
                  placeholder={searchPlaceholder}
                  maxLength={512}
                  value={searchText}
                  onChange={this.updateSearch}
                />
                <div className="ais-SearchBox-submit">
                  <svg
                    className="ais-SearchBox-submitIcon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 40 40"
                  >
                    <path
                      style={{
                        fill: '#0071c3',
                      }}
                      id="storeSelectorSearchIcon"
                      d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
                    />
                  </svg>
                </div>
              </div>
            )}
          </ModalHeaderContentContainer>
        </ModalHeader>

        {stateCollection.length > 0 && (
          <SearchContentContainer>
            {stateCollection.map((store) => (
              <SearchResultElement key={`${store.id}`} closeStoreSelector={closeModalAction} {...store} />
            ))}
            {this.providedCollection.length === 1 && searchText === '' && (
              <SingleElementFoundMessage>
                <img
                  style={{ width: '22px', marginRight: '10px' }}
                  alt="Información"
                  src="/catalogo/images/icon_info.svg"
                />
                {singleElementMessage}
              </SingleElementFoundMessage>
            )}
          </SearchContentContainer>
        )}

        {stateCollection.length === 0 && searchText !== '' && (
          <SearchContentContainer>
            <NoElementsFound>
              <img style={{ height: '140px' }} alt="Lider Logo" src="/catalogo/images/delivery_store.svg" />
              <span style={{ textAlign: 'center', color: '#c4c4c4' }}>{noFoundMessage}</span>
            </NoElementsFound>
          </SearchContentContainer>
        )}
      </Fragment>
    )
  }
}

CollectionSearchComponent.defaultProps = {
  searchPlaceholder: '',
  closeModalAction: () => {},
}

CollectionSearchComponent.propTypes = {
  collection: PropTypes.array.isRequired,
  searchKeys: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  singleElementMessage: PropTypes.string.isRequired,
  SearchResultElement: PropTypes.any.isRequired,
  searchPlaceholder: PropTypes.string,
  noFoundMessage: PropTypes.string.isRequired,
  closeModalAction: PropTypes.func,
}

export default CollectionSearchComponent
